<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="false">
  <form [formGroup]="customerDetailsForm" (ngSubmit)="onUpdatePhone()">
    <ion-label class="title">{{'ACCOUNT.phone.enter' | translate}}</ion-label>
    <p *ngIf="message">{{ message }}</p>
    <div
      class="account-phone-group"
      [ngClass]="{'only-ch': isCHCustomer, 'invalid': (customerDetailsForm.touched && phoneControl.invalid)}"
      [class.only-ch]="isCHCustomer"
    >
      <label>{{'ACCOUNT.phone.new' | translate}}</label>
      <div>
        <ngx-intl-tel-input
          [selectedCountryISO]="inputOptions.initialCountry"
          [preferredCountries]="inputOptions.preferredCountries"
          [separateDialCode]="inputOptions.separateDialCode"
          [onlyCountries]="inputOptions.onlyCountries"
          [phoneValidation]="true"
          [customPlaceholder]="mobilePhonePlaceholder"
          (countryChange)="onCountryChange($event)"
          name="phone"
          formControlName="phone"
          (touchmove)="$event.stopPropagation()"
        />
      </div>
    </div>

    <div class="ion-input__errors">
      <span *ngIf="(customerDetailsForm.touched && phoneControl.invalid)">{{'ACCOUNT.phone.please' | translate}}</span>
    </div>
    <ion-button (click)="onUpdatePhone()" mode="ios">{{'SHARED.actions.saveChanges' | translate}}</ion-button>
  </form>
</ion-content>
